export const GET_CURRENT_JACKPOT_FOR_BRAND = `
  query GetCurrentJackpotForBrand(
    $operatorId: String!
    $brandId: String!
    $currency: String!
    $gameCode: String!
  ) {
    jackpot {
      getCurrentJackpotForBrand(
        operatorId: $operatorId
        brandId: $brandId
        currency: $currency
        gameCode: $gameCode
      ) {
        status
        success
        message
        code
        data {
          jackpotId
          jackpotName
          jackpotFilledStatus
          jackpotMaturityValue
        }
      }
    }
  }
`

export const GET_CURRENT_JACKPOT_FOR_BRAND_USER_SPECIFIC = `
  query GetCurrentJackpotForBrandUserSpecific(
    $operatorId: String!
    $brandId: String!
    $currency: String!
    $playerId: String!
    $gameCode: String!
  ) {
    jackpot {
      getCurrentJackpotForBrandUserSpecific(
        operatorId: $operatorId
        brandId: $brandId
        currency: $currency
        playerId: $playerId
        gameCode: $gameCode
      ) {
        status
        success
        message
        code
        data {
          jackpotId
          jackpotName
          jackpotFilledStatus
          jackpotMaturityValue
          userContributionPercentage
        }
      }
    }
  }
`

export const GET_USER_ALL_TICKETS_FOR_JACKPOT = `
  query GetUserAllTicketsForJackpot($jackpotId: String!, $playerId: String!) {
    jackpot {
      getUserAllTicketsForJackpot(jackpotId: $jackpotId, playerId: $playerId) {
        status
        success
        message
        code
        data {
          userTickets {
            dateTime
            ticketIds
            totalTickets
          }
        }
      }
    }
  }
`

export const GET_TOP_CURRENT_JACKPOT_CONTRIBUTIONS = `
  query GetTopCurrentJackpotContributions(
    $operatorId: String!
    $brandId: String!
    $currency: String!
    $playerId: String!
  ) {
    jackpot {
      getTopCurrentJackpotContributions(
        operatorId: $operatorId
        brandId: $brandId
        currency: $currency
        playerId: $playerId
      ) {
        status
        success
        message
        code
        data {
          currentJackpotContributions {
            jackpotId
            jackpotName
            jackpotTopContributions {
              userId
              winChance
              ticketsAllocated
            }
            currentUserJackpotContributions {
              userId
              winChance
              ticketsAllocated
            }
          }
        }
      }
    }
  }
`

export const GET_PRIZE_DISTRIBUTION_DETAILS_FOR_JACKPOT = `
  query GetPrizeDistributionDetailsForJackpot($jackpotId: String!) {
    jackpot {
      getPrizeDistributionDetailsForJackpot(jackpotId: $jackpotId) {
        status
        success
        message
        code
        data {
          jackpotPrizeDistributions {
            position
            rewardAmount
          }
        }
      }
    }
  }
`

export const GET_USER_CONTRIBUTIONS_FOR_JACKPOT = `
  query GetUserContributionsForJackpot($jackpotId: String!, $playerId: String!) {
    jackpot {
      getUserContributionsForJackpot(jackpotId: $jackpotId, playerId: $playerId) {
        status
        success
        message
        code
        data {
          userContributions {
            dateTime
            contributionType
            stakeAmount
            contributionAmount
            ticketsAllocated
            betId
            ticketRange
          }
        }
      }
    }
  }
`

export const GET_USER_JACKPOT_HISTORY = `
  query GetUserJackpotHistory(
    $operatorId: String!
    $brandId: String!
    $currency: String!
    $playerId: String!
  ) {
    jackpot {
      getUserJackpotHistory(
        operatorId: $operatorId
        brandId: $brandId
        currency: $currency
        playerId: $playerId
      ) {
        status
        success
        message
        code
        data {
          jackpotHistoryDetails {
            jackpotId
            jackpotName
            jackpotMaturityValue
            endedDate
            userReward
          }
        }
      }
    }
  }
`

export const GET_USER_JACKPOT_HISTORY_RESULTS = `
  query GetUserJackpotHistoryResults($jackpotId: String!, $playerId: String!) {
    jackpot {
      getUserJackpotHistoryResults(jackpotId: $jackpotId, playerId: $playerId) {
        status
        success
        message
        code
        data {
          results {
            position
            userId
            winningTicket
            rewardAmount
          }
        }
      }
    }
  }
`
